import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ncis-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonComponent {}
